
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './contexts/AppContext';
import { UIProvider } from './contexts/UIContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
// Diagnostic: log mounting of providers to help trace provider order issues in prod
console.log('Index: mounting providers - UIProvider -> AppProvider -> App');
try {
  // Log runtime React versions to detect duplicate/mismatched React builds
  // eslint-disable-next-line no-console
  console.log('React runtime version:', (React as any).version || 'unknown');
  // eslint-disable-next-line no-console
  console.log('ReactDOM createRoot available:', typeof (ReactDOM as any).createRoot === 'function');
} catch (e) {
  console.warn('Could not log React versions', e);
}
root.render(
  <React.StrictMode>
    <UIProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </UIProvider>
  </React.StrictMode>
);
